module.exports = __webpack_public_path__ + "img/email.b57b95c4.png";